export default {
  isLoggedIn: state => state.isLoggedIn,
  apiKey: state => state.apiKey,
  config: state => state.config,
  tenant: state => state.tenant,
}
